const API_BASE = '/api/nodes';

function getAuthHeaders() {
  const token = localStorage.getItem('adminToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchNodes(search = '') {
  const params = search ? `?search=${encodeURIComponent(search)}` : '';
  const response = await fetch(`${API_BASE}${params}`);
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch nodes');
  }
  return data.data;
}

export async function fetchNode(id) {
  const response = await fetch(`${API_BASE}/${id}`);
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch node');
  }
  return data.data;
}

export async function createNode(nodeData) {
  const response = await fetch(API_BASE, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    },
    body: JSON.stringify(nodeData)
  });
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to create node');
  }
  return data.data;
}

export async function updateNode(id, updates) {
  const response = await fetch(`${API_BASE}/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    },
    body: JSON.stringify(updates)
  });
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to update node');
  }
  return data.data;
}

export async function deleteNode(id) {
  const response = await fetch(`${API_BASE}/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to delete node');
  }
  return data.data;
}

export async function deleteAllNodes() {
  const response = await fetch(API_BASE, {
    method: 'DELETE',
    headers: {
      'X-Confirm-Delete': 'yes',
      ...getAuthHeaders()
    }
  });
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to delete all nodes');
  }
  return data.data;
}

export async function importNodes(nodesArray) {
  const response = await fetch(`${API_BASE}/bulk`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    },
    body: JSON.stringify({ nodes: nodesArray })
  });
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to import nodes');
  }
  return data.data;
}

export async function importNodesFromFile(file) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_BASE}/import`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: formData
  });
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to import nodes from file');
  }
  return data.data;
}

export async function geolocateIP(ip) {
  const response = await fetch(`${API_BASE}/geolocate/${ip}`);
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to geolocate IP');
  }
  return data.data;
}

export async function getNodesCount() {
  const response = await fetch(`${API_BASE}/count`);
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to get nodes count');
  }
  return data.count;
}

export async function login(password) {
  const response = await fetch('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ password })
  });
  const data = await response.json();
  if (!data.success) {
    throw new Error(data.error || 'Failed to login');
  }
  return data.token;
}
